import { hasKitchenBindToken } from '@/utils/kitchenBinding';
import { isKitchenRoute } from '@/utils/authUtils';
import { restorePartnerPwaHead } from '@/utils/kitchenPwaHead';

/** Partner-PWA manifest only when not in Küchen-Bind flow (never on /kueche). */
export const syncPartnerPwaHead = (route) => {
  if (typeof document === 'undefined') return;
  if (hasKitchenBindToken()) return;
  if (route && isKitchenRoute(route)) return;
  restorePartnerPwaHead();
};
